"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapOpeningHoursToSchedules = void 0;
const first_1 = __importDefault(require("lodash/first"));
const last_1 = __importDefault(require("lodash/last"));
function mapOpeningHoursToSchedules(t, openingHours) {
    const time = (hms) => hms.split(':').splice(0, 2).join(':');
    const shortDay = (i = 0) => t([
        'common:week.shorten.monday',
        'common:week.shorten.tuesday',
        'common:week.shorten.wednesday',
        'common:week.shorten.thursday',
        'common:week.shorten.friday',
        'common:week.shorten.saturday',
        'common:week.shorten.sunday',
    ][i]);
    const daysForSchedule = openingHours
        .map(({ shifts, open }) => (open ? shifts : []))
        .map((shifts) => shifts
        .map(({ from, to }) => to
        ? t('agency:openingHours.shift', { from: time(from), to: time(to) })
        : t('agency:openingHours.from', { from: time(from) }))
        .join(' / '))
        .reduce((acc, schedule, i) => {
        var _a;
        if ((_a = acc[schedule]) === null || _a === void 0 ? void 0 : _a.length) {
            acc[schedule].push(i);
        }
        else {
            acc[schedule] = [i];
        }
        return acc;
    }, {});
    return Object.entries(daysForSchedule)
        .sort((a, b) => (a[1][0] > b[1][0] ? 1 : -1))
        .filter(([schedules]) => schedules)
        .map(([schedule, days]) => days.length === 1
        ? `${shortDay((0, first_1.default)(days))}: ${schedule}`
        : `${t('agency:openingHours.daysRange', {
            from: shortDay((0, first_1.default)(days)),
            to: shortDay((0, last_1.default)(days)),
        })}: ${schedule}`);
}
exports.mapOpeningHoursToSchedules = mapOpeningHoursToSchedules;
//# sourceMappingURL=mapOpeningHoursToSchedules.js.map